<header class="edit-modal__header">
    <div class="edit-modal__title-wrap">
        <div class="edit-modal__title-badge" aria-hidden="true">
            <span></span>
        </div>

        <div class="edit-modal__title">
            <span>{{ title }}</span>
            <small>Configure os dados do turno.</small>
        </div>
    </div>

    <button type="button" class="edit-modal__close" (click)="close()" aria-label="Fechar">
        <img src="assets/icons/close.svg" alt="" />
    </button>
</header>


<form class="edit-modal" [formGroup]="form">
    <div class="edit-modal__row">
        <div class="edit-modal__field">
            <label class="edit-modal__label">Turno</label>
            <select class="edit-modal__input" [disabled]="data.mode === 'edit'" formControlName="NU_TRNO">
                <option [ngValue]="0">Matutino</option>
                <option [ngValue]="1">Vespertino</option>
                <option [ngValue]="2">Noturno</option>
            </select>
        </div>

        <div class="edit-modal__field">
            <label class="edit-modal__label">Período</label>
            <input class="edit-modal__input" [value]="periodoAtual" disabled />
        </div>
    </div>

    <div class="edit-modal__row">
        <div class="edit-modal__field">
            <label class="edit-modal__label">Capacidade</label>
            <input class="edit-modal__input" type="number" min="0" formControlName="QT_CAPA" />
        </div>

        <div class="edit-modal__field">
            <label class="edit-modal__label">Qtd. Agendamento</label>
            <input class="edit-modal__input" type="number" min="0" formControlName="QT_AGND" />
        </div>
    </div>

    <div class="edit-modal__row edit-modal__row--single">
        <div class="edit-modal__field">
            <label class="edit-modal__label">Carga</label>
            <select class="edit-modal__input" formControlName="FK_CRGA" [disabled]="data.mode === 'edit'">
                <option [ngValue]="0" disabled>Selecione uma carga</option>
                @for(item of cargaOptions;track $index) {
                <option [ngValue]="item.value">{{item.name}}</option>
                }
            </select>
        </div>
    </div>

    <div class="edit-modal__field">
        <label class="edit-modal__label">Destinatário</label>
        <select class="edit-modal__input" formControlName="FK_DTNR" [disabled]="data.mode === 'edit'">
            <option [ngValue]="0">Selecione um destinatário</option>
            @for(item of destinatarioOptions; track $index) {
            <option [ngValue]="item.value">{{ item.name }}</option>
            }
        </select>
    </div>

    <footer class="edit-modal__footer">
        <button type="button" class="edit-modal__btn edit-modal__btn--ghost" (click)="close()">
            Cancelar
        </button>

        <button type="submit" class="edit-modal__btn edit-modal__btn--primary" (click)="save()" [disabled]="form.invalid">
            Salvar
        </button>
    </footer>
</form>